import api from "./api";
import { getStoredUser, getStoredClientId } from "../utils/tokenUtils";

export const testcaseService = {
  getTestCases: async (project_id, params = {}) => {
    const response = await api.post("/testcase/list", {
      project_id,
      ...params,
    });
    return response.data;
  },

  getTestCaseById: async (project_id, test_case_id) => {
    try {
      const response = await api.post("/testcase/get", {
        project_id,
        test_case_id,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createTestCase: async (project_id, testCaseData) => {
    const response = await api.post("/testcase/create", {
      project_id,
      ...testCaseData,
    });
    return response.data;
  },

  updateTestCase: async (project_id, test_case_id, data) => {
    const response = await api.post("/testcase/update", {
      project_id,
      test_case_id,
      ...data,
    });
    return response.data;
  },

  deleteTestCase: async (project_id, test_case_id) => {
    const response = await api.post("/testcase/delete", {
      project_id,
      test_case_id,
    });
    return response.data;
  },

  updateTestCaseStatus: async (project_id, test_case_id, status) => {
    const response = await api.post("/testcase/status", {
      project_id,
      test_case_id,
      status,
    });
    return response.data;
  },

  bulkGetTestCases: async (project_id, testCaseIds) => {
    const response = await api.post("/testcase/bulk", {
      project_id,
      test_case_ids: testCaseIds,
    });
    return response.data;
  },

  copyTestCase: async (test_case_id, project_id, section_id = null) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      test_case_id,
      project_id,
      section_id: section_id, // Use section_id, API may accept folder_id for backward compatibility
      folder_id: section_id, // Keep for backward compatibility
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/testcase/copy", payload);
    return response.data;
  },

  moveTestCase: async (
    test_case_id,
    target_project_id = null,
    target_section_id = null,
  ) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      test_case_id,
      target_project_id,
      target_section_id: target_section_id, // Use section_id, API may accept folder_id for backward compatibility
      target_folder_id: target_section_id, // Keep for backward compatibility
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/testcase/move", payload);
    return response.data;
  },

  bulkEditTestCases: async (test_case_ids, updates) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      test_case_ids,
      updates,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/testcase/bulk-edit", payload);
    return response.data;
  },

  bulkDeleteTestCases: async (test_case_ids) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      test_case_ids,
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/testcase/bulk-delete", payload);
    return response.data;
  },

  bulkMoveTestCases: async (
    test_case_ids,
    target_project_id = null,
    target_section_id = null,
  ) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      test_case_ids,
      target_project_id,
      target_section_id: target_section_id, // Use section_id, API may accept folder_id for backward compatibility
      target_folder_id: target_section_id, // Keep for backward compatibility
      client_id: storedClientId || user?.client_id,
    };
    const response = await api.post("/testcase/bulk-move", payload);
    return response.data;
  },

  assignTestCase: async (project_id, test_case_id, assignedTo) => {
    const response = await api.post("/testcase/assign", {
      project_id,
      test_case_id,
      assignedTo: assignedTo || null,
    });
    return response.data;
  },
};
